import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  button: {
    backgroundColor: 'rgba(255,255,255,0.8)',
    borderRadius: '8px',
    border: '1px solid var(--color-main-orange)',
    color: 'var(--color-main-orange)',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.8)',
    },
  },
}));

type ModalButtonProps = {
  onClick: () => void;
  children?: React.ReactNode;
};

export function ModalButton({ onClick, children }: ModalButtonProps) {
  const styles = useStyles();

  return (
    <IconButton size="small" className={styles.button} onClick={onClick}>
      {children}
    </IconButton>
  );
}
